import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202511: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202511",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-11-01",
  endDate: "2025-11-30",
  impressions: 13369,
  clicks: 225,
  adsSpendDollars: 1421,
  budgetDollars: 1500,
  salesDollars: 11465,
  bestEstimateRoas: 8.07,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.95,
  newCustomersAcquired: 9,
  dataAvailableAtDate: "2025-12-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
